<div class="layout-shop">

  @if(isContentLoading() || !isContentLoaded()) {
  <section class="loading-animation-content d-flex flex-column align-items-center justify-content-center shop-loader">
    <div class="loader">
      @for (item of [0,0,0,0,0]; track $index) {
      <div class="bg-primary"></div>
      }
    </div>
    @if (isMobile()) {
    <h5 class="h5-semibold animated fadeIn text-center px-3">
      Just a moment! We’re loading the shop for you.
    </h5>
    } @else {
    <h3 class="h3-semibold animated fadeIn text-center">
      Just a moment! We’re loading the shop for you.
    </h3>
    }
  </section>
  }
  <!-- Sidebar -->
  @if(!isMobile()) {
  <div class="layout-shop__sidebar {{hasGlobalMessages() ? 'height-sidebar-global-message' : 'default-sidebar-height'}}"
    [class.sidebar--closed]="false">
    <div class="overlay" (click)="toggleSidebar()"></div>
    <app-sidebar (outIsMenuReady)="scrollIntoView()"></app-sidebar>
  </div>
  }

  <!-- Main content -->
  <div class="layout-shop__main" name="scroll-to-top-ref" [class.height-layout-shop__main]="!hasGlobalMessages()"
    [class.height-layout-shop__main-global-message]="hasGlobalMessages()" #layoutShopMain (scroll)="onScroll($event)"
    id="layoutShopMain">

    @if(!marketStatus().isOpen) {
    <div class="closed-market-container animated fadeIn">
      <div class="alert" role="alert">
        <span class="material-symbols-outlined mat-icon-fill icon">
          calendar_today
        </span>
        <div class="text-container">

          <p class="header">{{closedMarket().title}}</p>
          <p class="legend">{{closedMarket().legend}}</p>
        </div>
      </div>
    </div>
    }

    @if(isShowingShopFilters() && !isMobile()) {
    <div class="shop-filters" [class.mb-3]="isFilteringByTags()">
      <app-search-bar></app-search-bar>
    </div>
    }

    <div class="container-fluid">

      @if (isFilteringByTags() && isMobile()) {
      <div class="shop-tags-filter">
        <app-filtering-tags></app-filtering-tags>
        <hr class="animated fadeIn">
      </div>
      }

      @if (filters().size) {
      <ul class="filter-chips-container" [class.filtering-by-tags]="isFilteringByTags() && isMobile()">
        @for (filter of filters().entries(); track $index) {
        <li>
          <mat-chip-row (removed)="removeChipFilter(filter[0])" [editable]="true" class="bg-secondary bg-opacity-25">
            <div class="d-flex gap-1">
              <b>{{filter[1].type}}:</b> <span class="fst-italic text-decoration-underline">{{filter[1].value}}</span>
            </div>
            <button matChipRemove [attr.aria-label]="'remove ' + filter[0]">
              <span class="material-symbols-outlined">
                close
              </span>
            </button>
          </mat-chip-row>
        </li>
        }
      </ul>
      }

      @if (isFilteringByTags() && !isMobile()) {
      <div class="shop-tags-filter" [class.filtering-by-searchbar]="filters().size > 0">
        <app-filtering-tags></app-filtering-tags>
        <hr class="animated fadeIn">
      </div>
      }

      @if (!isContentLoading() && isContentLoaded()) {
      @if (!productsSignal().length) {
      <app-empty-message [message]="emptyMessage" class="mt-4"></app-empty-message>
      }
      }

      <div class="row product-card-grid" [class.padding-at-bottom-sm]="productsSignal().length <= 3">
        @defer (on viewport) {
        @if (productsSignal()) {

        <div class="" id="scroll-to-top-ref"></div>

        @for (product of productsSignal(); track product.id + '-' + $index) {

        @if (product.categoryInView?.show) {
        @if (product.categoryInView?.banner) {
        <a [href]="product.categoryInView?.url ? product.categoryInView?.url : 'javascrip:void(0)'"
          [attr.category-id]="product.category.id" [id]="product.category.id"
          [attr.shop-data-anchor-link]="product.categoryAnchorLink">
          <img [src]="product.categoryInView?.banner" alt="Banner of category {{product.subcategory.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4">
        </a>
        } @else if(displayCategoryName()) {
        <h2 [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product?.subcategorySon?.id ?? -1" [id]="product.category.id"
          [attr.shop-data-anchor-link]="product.categoryAnchorLink" #category>
          {{ product.category.name }}
        </h2>
        }
        }

        @if (product.subCategoryInView?.show) {
        @if (product.subCategoryInView?.banner) {
        <a [href]="product.subCategoryInView?.url ? product.subCategoryInView?.url : 'javascrip:void(0)'"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product?.subcategorySon?.id ?? -1"
          [id]="product.category.id + '-' + product.subcategory.id"
          [attr.shop-data-anchor-link]="product.subcategoryAnchorLink" #subcategory>
          <img [src]="product.subCategoryInView?.banner" alt="Banner of subcategory {{product.subcategory.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4">
        </a>
        } @else {
        <h3 [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product?.subcategorySon?.id ?? -1"
          [id]="product.category.id + '-' + product.subcategory.id"
          [attr.shop-data-anchor-link]="product.subcategoryAnchorLink" #subcategory>
          {{ product.subcategory.name }}
        </h3>
        }
        }

        @if (product.subCategorySonInView?.show) {
        <h4 [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product.subcategorySon.id"
          [id]="product.category.id + '-' + product.subcategory.id + '-' + product.subcategorySon.id"
          [attr.shop-data-anchor-link]="product.subcategorySonAnchorLink" #subcategorySon>
          {{ product.subcategory.name }}: <span class="text-secondary">{{ product.subcategorySon.name }}</span>
        </h4>
        }


        @defer (on viewport; prefetch on immediate) {
        <div class="col-xxl-3 col-lg-4 col-6" id="{{product.id}}" (mouseenter)="onProductCardHover(product.id)">
          <div class="product-card-grid__item">
            @let productDetails = this.productDetails().get(product.id);
            <app-product-card-v2 [cardResume]="{ product, settings: {}, productDetails:  productDetails}"
              (onComponentReady)="onProductCardReady(product.id)" [isFromShop]="!!productDetails">
            </app-product-card-v2>
          </div>
        </div>
        } @placeholder {
        <div class="col-xxl-3 col-lg-4 col-6" id="{{product.id}}">
          <div class="product-card-grid__item__placeholder">
          </div>
        </div>
        }

        }
        }

        }
        @placeholder {
        <div></div>
        }
      </div>
    </div>
    @if (productsSignal().length) {
    @defer(on timer(500ms)) {
    <app-footer></app-footer>
    }
    }
  </div>



</div>